var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "sideMenu" } },
    [
      _c("transition", { attrs: { name: "sidemenu-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visible,
                expression: "visible"
              }
            ],
            staticClass: "sidemenu-wraper"
          },
          [
            _c(
              "div",
              {
                staticClass: "sidemenu-container",
                class: { "sidemenu-open": _vm.visible }
              },
              [
                _c(
                  "ul",
                  { staticClass: "sidemenu-content" },
                  [
                    _vm._l(_vm.menuChooseList, function(item, index) {
                      return _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "popover",
                              rawName: "v-popover:popover",
                              arg: "popover"
                            }
                          ],
                          key: index,
                          staticClass: "menu-item overallCenter",
                          on: {
                            click: function($event) {
                              return _vm.handleSwitchMenu(item, index)
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "box-position" },
                            [
                              _c("svg-icon", {
                                staticStyle: {
                                  "font-size": "1.3vw",
                                  "margin-bottom": "0.5vh"
                                },
                                attrs: { "icon-class": item.icon }
                              }),
                              _c("span", [_vm._v(_vm._s(item.name))])
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    _c("div", { attrs: { id: "switchMenu" } })
                  ],
                  2
                )
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }